const Grid = require('components/Grid/Grid');
module.exports = Grid;
